window.previewModal = document.getElementById('preview-modal');
if (!window.previewModal) {
    window.previewModal = document.createElement('dialog');
    previewModal.setAttribute('id', 'preview-modal');
    previewModal.setAttribute('class', 'mobile-sheet');
    document.body.appendChild(previewModal);
    if (window.JN && window.JN.mobileSheet) JN.mobileSheet.wireOne(previewModal);
}
function showSidebarAsPopup() {
    const hiw = document.getElementById('how-it-works')
    const d = document.createElement('div');
    d.innerHTML = hiw.outerHTML;
    d.childNodes[0].removeAttribute('id');
    d.childNodes[0].style.height = 'auto';
    d.childNodes[0].style.maxHeight = 'calc(100vh - 40px)';
    d.childNodes[0].style.bottom = 0;
    d.childNodes[0].getElementsByClassName('hiw-show')[0].remove();
    previewModal.innerHTML = '<div>' + d.innerHTML + `
        <div class="hiw-close tw-absolute tw-bg-black tw-rounded-full tw-px-2 tw-py-3 tw-leading-[0px] tw-text-white"
            style="right: 20px" onclick="previewModal.close();">
          &times;
        </div>
    `;
    previewModal.showModal();
    setTimeout(()=>{
        previewModal.getElementsByClassName('hiw-close')[0].style.bottom=`${previewModal.childNodes[0].childNodes[0].clientHeight+8}px`
    }, 1)
}

$(document).ready(function () {
    $('.read-more').click((e) => {
        const self=$(e.target);
        self.hide().siblings('span').show('slow')
    })
    $('.hiw-show').on('click', showSidebarAsPopup);
});
